import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractCommissionAgent } from '../../../models/Entities/Contracts/ContractCommissionAgent';
import { ContractCommissionAgentConcept } from '../../../models/Entities/Contracts/ContractCommissionAgentConcept';

export default function ContractCommissionAgentsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  // Log para debugging
  if (a.type?.includes('CONTRACT_COMMISSION_AGENT_UPDATE') || a.type?.includes('CONTRACT_COMMISSION_AGENT_CREATE')) {
    console.log('CommissionAgentsReducer - Action:', a.type);
    console.log('Estado actual - isUpdatingAll:', currentState.isUpdatingAll, 'isSaving:', currentState.isSaving);
  }

  switch (a.type) {
    case 'CONTRACT_COMMISSION_AGENT_UPDATE_REQUEST': {
      console.log('Procesando UPDATE_REQUEST');
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionAgent.contractId);
      if (contract) {
        console.log('Contract encontrado, seteando isUpdatingAll = true');
        return {
          ...currentState,
          isUpdatingAll: true,
          isUpdatingAllSuccess: false,
          FailUpdatingAll: false,
          list: [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), {
            ...contract
          }]
        };
      }
      console.log('Contract NO encontrado');
      return currentState;
    }
    case 'CONTRACT_COMMISSION_AGENT_GET_ALL_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, commissionAgents: a.contractCommissionAgents }] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_GET_BY_ID_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionAgent.contractId);
      if (CurrentContract) {
        const existingCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.contractCommissionAgent.id
        );
        const updatedCommissionAgent = {
          ...a.contractCommissionAgent,
          Concepts: existingCommissionAgent?.Concepts || a.contractCommissionAgent.Concepts || []
        };
        CurrentContract = {
          ...CurrentContract,
          commissionAgents: [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.contractCommissionAgent.id)),
            updatedCommissionAgent,
          ],
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_UPDATE_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionAgent.contractId);
      if (contract) {
        const existingCommissionAgent = contract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.contractCommissionAgent.id
        );
        const updatedCommissionAgent = {
          ...a.contractCommissionAgent,
          Concepts: existingCommissionAgent?.Concepts || a.contractCommissionAgent.Concepts || []
        };
        return {
          ...currentState,
          isUpdatingAll: false,
          isUpdatingAllSuccess: true,
          FailUpdatingAll: false,
          list: [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), {
              ...contract,
              commissionAgents: [
                ...((contract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.contractCommissionAgent.id)),
                updatedCommissionAgent,
              ],
            }]
        };
      }
      return currentState;
    }
    case 'CONTRACT_COMMISSION_AGENT_CREATE_REQUEST': {
      return {
        ...currentState,
        isSaving: true,
        isSavingSuccess: false,
        FailSaving: false
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CREATE_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionAgent.contractId);
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: true,
        FailSaving: false,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), {
              ...contract,
              commissionAgents: [...(contract.commissionAgents || []), a.contractCommissionAgent],
            }]
          : currentState.list,
      };
    }

    // Associated contract commission agents
    case 'CONTRACT_COMMISSION_AGENT_GET_ALL_BY_ASSOCIATED_CONTRACT_ID_REQUEST': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), {
              ...contract,
              isGettingCommissionAgentContractAssociation: true,
              GettingCommissionAgentContractAssociationSuccess: false,
              FailGettingCommissionAgentContractAssociation: false,
              ErrorGettingCommissionAgentContractAssociation: undefined,
            }]
          : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_GET_ALL_BY_ASSOCIATED_CONTRACT_ID_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          commissionAgents: a.contractCommissionAgents,
          isGettingCommissionAgentContractAssociation: false,
          GettingCommissionAgentContractAssociationSuccess: true,
          FailGettingCommissionAgentContractAssociation: false,
          ErrorGettingCommissionAgentContractAssociation: undefined,
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_GET_ALL_BY_ASSOCIATED_CONTRACT_ID_FAILURE': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), {
              ...contract,
              isGettingCommissionAgentContractAssociation: false,
              GettingCommissionAgentContractAssociationSuccess: false,
              FailGettingCommissionAgentContractAssociation: true,
              ErrorGettingCommissionAgentContractAssociation: a.error,
            }]
          : currentState.list,
      };
    }

    // Commission agent concepts
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_REQUEST': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          const updated = {
            ...CurrentCommissionAgent,
            isGettingCommissionAgentConcepts: true,
            isGettingCommissionAgentConceptsSuccess: false,
            FailGettingCommissionAgentConcepts: false,
            ErrorGettingCommissionAgentConcepts: undefined,
          } as ContractCommissionAgent;
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.commissionAgentId)),
            updated,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractid);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          const updated = {
            ...CurrentCommissionAgent,
            isGettingCommissionAgentConcepts: false,
            isGettingCommissionAgentConceptsSuccess: true,
            FailGettingCommissionAgentConcepts: false,
            ErrorGettingCommissionAgentConcepts: undefined,
            Concepts: a.contractCommissionAgentConcepts as ContractCommissionAgentConcept[],
          } as ContractCommissionAgent;
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.commissionAgentId)),
            updated,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_FAILURE': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          const updated = {
            ...CurrentCommissionAgent,
            isGettingCommissionAgentConcepts: false,
            isGettingCommissionAgentConceptsSuccess: false,
            FailGettingCommissionAgentConcepts: true,
            ErrorGettingCommissionAgentConcepts: a.error,
          } as ContractCommissionAgent;
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.commissionAgentId)),
            updated,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_UPDATE_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionAgentConcept.contractId);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.contractCommissionAgentConcept.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          const updatedConcepts = [
            ...((CurrentCommissionAgent.Concepts || []).filter((item: ContractCommissionAgentConcept) => item.id !== a.contractCommissionAgentConcept.id)),
            a.contractCommissionAgentConcept,
          ];
          const updatedCommissionAgent = {
            ...CurrentCommissionAgent,
            Concepts: updatedConcepts
          };
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.contractCommissionAgentConcept.commissionAgentId)),
            updatedCommissionAgent,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_CREATE_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          const updatedConcepts = [...(CurrentCommissionAgent.Concepts || []), ...a.contractCommissionAgentConcept];
          const updatedCommissionAgent = {
            ...CurrentCommissionAgent,
            Concepts: updatedConcepts
          };
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.commissionAgentId)),
            updatedCommissionAgent,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_DELETE_SUCCESS': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentCommissionAgent = CurrentContract.commissionAgents?.find(
          (item: ContractCommissionAgent) => item.id === a.commissionAgentId
        );
        if (CurrentCommissionAgent) {
          CurrentCommissionAgent.Concepts = (CurrentCommissionAgent.Concepts || []).filter(
            (item: ContractCommissionAgentConcept) => item.id !== a.contractCommissionAgentConceptId
          );
          CurrentContract.commissionAgents = [
            ...((CurrentContract.commissionAgents || []).filter((item: ContractCommissionAgent) => item.id !== a.commissionAgentId)),
            CurrentCommissionAgent,
          ];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
